import React, { useContext } from "react";
import { UserContext } from "../../state/userContext";
import { Navigate } from "react-router-dom";

// @ts-ignore
const Protected: React.FC<{ children?: React.ReactNode }> = (props) => {
  const userContext = useContext(UserContext);

  return userContext.isLogged ? props.children : <Navigate to="/login" replace />;
};

export default Protected;
